// useCatalogLiveNode.js

import { useEffect, useMemo, useState } from 'react';

import { useNodeTypes } from 'context/NodeTypesContext';
import { subscribeToTypeCatalogEntry } from 'services/catalog/TypeCatalogService';
import {
  applyCatalogLiveRead,
  getNodeCatalogId,
} from 'utilities/PlatformCatalog';

/**
 * Overlays live catalog field values (title, cover, …) onto an adopted workspace node.
 *
 * @param {object|null|undefined} node
 * @returns {object|null|undefined}
 */
export default function useCatalogLiveNode(node) {
  const { getType } = useNodeTypes();
  const [catalogEntry, setCatalogEntry] = useState(null);

  const catalogId = getNodeCatalogId(node);
  const typeKey = String(node?.type || '').trim();

  useEffect(() => {
    if (!catalogId || !typeKey) {
      setCatalogEntry(null);
      return undefined;
    }

    return subscribeToTypeCatalogEntry(typeKey, catalogId, (entry) => {
      setCatalogEntry(entry || null);
    });
  }, [catalogId, typeKey]);

  return useMemo(() => {
    if (!node) return node;
    if (!catalogId || !catalogEntry) return node;
    return applyCatalogLiveRead(node, catalogEntry, getType(typeKey)) || node;
  }, [catalogEntry, catalogId, getType, node, typeKey]);
}
